/**
 * IssueService — adapter for gate issue data.
 *
 * Delegates to gateReportService, which fetches real gate artifacts from S3
 * (java_validation_report.json for structural, compile_result.json for compile).
 */

import {
  fetchGateFindings,
  fetchSourceContext,
  applyAutoFix,
  markTodo,
} from './gateReportService'

/**
 * Fetch all issues for a gate job.
 * Returns the same shape as fetchGateFindings.
 *
 * @param {string} jobId
 * @param {'structural'|'compile'} gateType
 * @param {string} apiBase
 * @returns {Promise<Array<Issue>>}
 */
export function fetchIssues(jobId, gateType, apiBase) {
  return fetchGateFindings(jobId, gateType, apiBase)
}

/**
 * Fetch full COBOL + Java source context for a single issue.
 * Used to provide code snippets when the editor cannot directly open the file.
 *
 * @param {string} issueId
 * @param {string} jobId
 * @param {'structural'|'compile'} gateType
 * @param {string} apiBase
 * @returns {Promise<{cobolFull: string, javaFull: string}>}
 */
export function fetchIssueContext(issueId, jobId, gateType, apiBase) {
  return fetchSourceContext(issueId, jobId, gateType, apiBase)
}

/**
 * Record a deterministic auto-fix for an issue.
 * When real API is wired: POST /gate/apply-fix { issue_id, job_id }.
 *
 * @param {string} issueId
 * @param {string} jobId
 * @param {string} apiBase
 */
export function applyIssueFix(issueId, jobId, apiBase) {
  return applyAutoFix(issueId, jobId, apiBase)
}

/**
 * Mark an issue as deferred (TODO stub).
 * When real API is wired: POST /gate/defer-issue { issue_id, job_id }.
 *
 * @param {string} issueId
 * @param {string} jobId
 * @param {string} apiBase
 */
export function deferIssue(issueId, jobId, apiBase) {
  return markTodo(issueId, jobId, apiBase)
}
